import React from "react";
import PropTypes from "prop-types";
import { Modal, Dropdown, Message } from "semantic-ui-react";

const EditFeedbackModal = ({
  isOpen,
  onClose,
  onSave,
  editText,
  setEditText,
  editCategory,
  setEditCategory,
  isSubmitting,
  error,
  setError,
  isMobile,
  categoryOptions,
  MIN_FEEDBACK_LENGTH = 10,
}) => {
  return (
    <Modal
      dimmer="blurring"
      open={isOpen}
      onClose={onClose}
      size={isMobile ? "fullscreen" : "small"}
      closeIcon
    >
      <Modal.Header>Edit Your Feedback</Modal.Header>
      <Modal.Content>
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {error && (
            <Message negative content={error} onDismiss={() => setError("")} />
          )}
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Category *
            </label>
            <Dropdown
              placeholder="Select feedback category"
              fluid
              selection
              value={editCategory}
              onChange={(e, { value }) => setEditCategory(value)}
              options={categoryOptions}
              style={{ marginBottom: "0.5rem" }}
            />
          </div>
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Your Feedback *
            </label>
            <textarea
              placeholder="What's on your mind?"
              value={editText}
              onChange={(e) => setEditText(e.target.value)}
              rows={5}
              style={{
                padding: "0.75rem",
                fontSize: "1rem",
                borderRadius: "8px",
                border: "1px solid #ddd",
                width: "100%",
                resize: "vertical",
                fontFamily: "inherit",
              }}
            />
            <div
              style={{
                fontSize: "0.8rem",
                color: "#666",
                marginTop: "0.25rem",
              }}
            >
              {editText.length}/{MIN_FEEDBACK_LENGTH} characters minimum
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                padding: "0.75rem 1.5rem",
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={isSubmitting || !editText.trim() || !editCategory}
              style={{
                padding: "0.75rem 1.5rem",
                backgroundColor:
                  isSubmitting || !editText.trim() || !editCategory
                    ? "#ccc"
                    : "#007bff",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor:
                  isSubmitting || !editText.trim() || !editCategory
                    ? "not-allowed"
                    : "pointer",
                fontSize: "1rem",
                fontWeight: "bold",
              }}
            >
              {isSubmitting ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

EditFeedbackModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  editText: PropTypes.string.isRequired,
  setEditText: PropTypes.func.isRequired,
  editCategory: PropTypes.string.isRequired,
  setEditCategory: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  setError: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  MIN_FEEDBACK_LENGTH: PropTypes.number,
};

EditFeedbackModal.defaultProps = {
  error: "",
  MIN_FEEDBACK_LENGTH: 10,
};

export default EditFeedbackModal;
